<template>
  <div class="businessAdd">
    <div class="contentWrap" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)">
      <el-table :data="tableData" style="width: 100%" stripe>
        <el-table-column prop="date" label="日期" width="180">
        </el-table-column>
        <el-table-column prop="name" label="名称" width="180">
        </el-table-column>
        <el-table-column prop="address" label="金额">
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
  import {
    json,
    wordData,
    utils
  } from '@/common/common.js'
  import {
    ajaxPost,
    api
  } from '@/common/request.js'
  export default {
    name: 'adminIndex',
    data() {
      return {
        tableData: [{
          date: '2019-11-11',
          name: '优惠券',
          address: '100元'
        }, {
          date: '2019-12-12',
          name: '优惠券',
          address: '50元'
        }, {
          date: '2019-12-12',
          name: '优惠券',
          address: '100元'
        }, {
          date: '2020-3-1',
          name: '优惠券',
          address: '80元'
        },, {
          date: '2020-3-1',
          name: '优惠券',
          address: '100元'
        }, {
          date: '2020-3-31',
          name: '优惠券',
          address: '10元'
        }, {
          date: '2020-3-31',
          name: '优惠券',
          address: '100元'
        }
        ]
      }


  },
  computed: {
      IMG_PREV() {
        return api.imgPrev
      }
    },
    components: {},
    methods: {
      prevImg(url) {},

      back() {},
      closeModal() {},
      getParam() {},
      getDetail() {},

    },
    mounted() {
      let _this = this
    },
  }
</script>

<style scoped lang="scss">
  * {
    // outline: 1px solid blue;
  }

  .businessAdd {
    background: #fff;
    ;
    padding: 20px;
    padding-bottom: 100px;

    .panelBlock {
      .panelTitle {
        font-weight: bold;
        padding: 10px 0;
      }

      .panelContent {
        .oneLine {
          padding: 10px;

          .label {
            display: inline-block;
            padding: 0 20px;
          }

          .rightInput {
            display: inline-block;
          }
        }
      }
    }

    .btnBox {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/discount/list.vue